export type Config = {
  apiUrl: string
  staticUrl: string
  /**
   * Public Google OAuth client ID for web / GIS, and Expo `webClientId`
   * (needed so Android/iOS get an ID token the API can verify).
   * Empty disables Google buttons when no platform-specific ID is set either.
   */
  googleClientId: string
  /** Android OAuth client ID (Expo `androidClientId`). Optional; falls back to googleClientId. */
  googleAndroidClientId: string
  /** iOS OAuth client ID (Expo `iosClientId`). Optional; falls back to googleClientId. */
  googleIosClientId: string
  /** Public Facebook app ID. Empty disables Facebook buttons. */
  facebookAppId: string
}

/**
 * Local-dev defaults so `pnpm dev:*` works without env files.
 * Production must set URLs via env / initConfig (Vite VITE_*, Expo EXPO_PUBLIC_*, Docker build-args).
 */
const defaultConfig: Config = {
  apiUrl: 'http://localhost:8090/',
  staticUrl: 'http://localhost:8090/',
  googleClientId: '',
  googleAndroidClientId: '',
  googleIosClientId: '',
  facebookAppId: '',
}

let config: Config = { ...defaultConfig }

export function initConfig(overrides: Partial<Config>) {
  const next = { ...defaultConfig, ...overrides }
  // Empty string env vars should not wipe defaults to blank
  if (!next.apiUrl?.trim()) next.apiUrl = defaultConfig.apiUrl
  if (!next.staticUrl?.trim()) next.staticUrl = defaultConfig.staticUrl
  config = next
}

export function getConfig(): Config {
  return config
}

export function getWsUrl(): string {
  const apiUrl = config.apiUrl.replace(/\/$/, '')
  if (apiUrl.startsWith('https://')) {
    return apiUrl.replace('https://', 'wss://')
  }
  return apiUrl.replace('http://', 'ws://')
}
